import { ILogService } from "../interfaces/log-service.interface";

export class LogService implements ILogService {

	constructor() { }

	public error(error: Error, context?: any, scope?: string) {
		// if (scope) this.logger.setTag('scope', scope);
		// this.logger.captureException(error, { contexts: context });
	}

	public warning(message: string, context?: any) {
		// this.logger.captureMessage(message, { 
		//   level: "warning",
		//   contexts: context
		// });
	}

	public message(message: string, context?: any, scope?: string) {
		// if (scope) this.logger.setTag('scope', scope);
		// this.logger.captureMessage(message, { 
		//   level: "info",
		//   contexts: context
		// });
	}

	public debug(message: string, context?: any) {
		// this.logger.captureMessage(message, {
		//   level: "debug",
		//   contexts: context
		// });
	}
}

export const logService = new LogService();